// extracted by mini-css-extract-plugin
module.exports = {"button":"button-GnyP6","button_facebook":"button_facebook-wGhPJ","button_google":"button_google-3rfBL"};